export default {"src":"/_next/static/media/powered-by-visonum.84b6d928.svg","height":33,"width":135};